import { commonTexts, settingsTexts } from 'consts/text';
import { getErrorMessageAndCode } from 'utils/errorHandlers/getErrorMessageAndCode';
import { apiErrorCodes } from 'consts/api/apiErrorCodes';

export const payUCredentialsAddEditErrorParser: (
    error: unknown,
    defaultErrorMessage?: string,
) => string = (error, defaultErrorMessage = commonTexts.errorMessages.unknown) => {
    const { code } = getErrorMessageAndCode(error);

    if (code === apiErrorCodes.INVALID_PAYU_CREDENTIALS) {
        return settingsTexts.payUCredentials.form.notifications.invalidPayUCredentialsErrorMessage;
    }

    return defaultErrorMessage;
};
